import React from "react";
import { Link } from "react-router-dom";
import { CookiePreferencesManager } from "../components/CookieBanner";
import FloatingScrollToTop from "../components/ScrollToTopButton";

const FooterLeftSplit = ({ onCookieUpdate }) => {
	const currentYear = new Date().getFullYear();

	return (
		<footer className="relative py-12 bg-white border-t border-slate-200">
			<div className="max-w-6xl mx-auto px-6">
				<div className="flex flex-col md:flex-row md:justify-between md:items-start gap-8">
					{/* Left side - Company info */}
					<div className="flex-1">
						<div className="flex items-center space-x-3 mb-4">
							<div className="w-10 h-10 bg-gradient-to-br from-slate-900 to-slate-700 rounded-xl flex items-center justify-center">
								<span className="text-white font-bold text-lg">K</span>
							</div>
							<div>
								<div className="text-xl font-bold text-slate-900">KGC Innovations Ltd</div>
							</div>
						</div>
						<p className="text-slate-600 mb-4 max-w-md">
							Enterprise technology solutions that drive measurable business growth. Trusted by organisations across the UK since 2014.
						</p>
						<div className="text-sm text-slate-500">
							Registred in England & Wales, No.16570829
						</div>
					</div>

					{/* Right side - Legal links */}
					<div className="flex-shrink-0">
						<div className="flex flex-col space-y-3">
							<Link
								to="/privacy-policy"
								className="text-slate-600 hover:text-slate-900 transition-colors text-sm"
							>
								Privacy Policy
							</Link>
							<Link
								to="/terms-of-service"
								className="text-slate-600 hover:text-slate-900 transition-colors text-sm"
							>
								Terms of Service
							</Link>
							<Link
								to="/cookie-policy"
								className="text-slate-600 hover:text-slate-900 transition-colors text-sm"
							>
								Cookie Policy
							</Link>
							<CookiePreferencesManager onUpdatePreferences={onCookieUpdate} />
						</div>
					</div>
				</div>

				{/* Copyright */}
				<div className="pt-8 border-t border-slate-200 mt-8 text-slate-500 text-sm">
					© {currentYear} KGC Innovations Ltd. All rights reserved.
				</div>
			</div>
			<FloatingScrollToTop />
		</footer>
	);
};

export default FooterLeftSplit;